import { ArrowBack } from '@mui/icons-material';
import {
  Card,
  Box,
  Grid,
  FormControlLabel,
  Stack,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { RiPulseFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  timeSince,
  WsDotIcon,
  WsDotColors,
  WsDotTextColors,
  WsButton,
  WsDrawer,
} from 'wisestep-base';

import ErrorLogger from '../../../../../providers/ErrorLogger';
import JobSelection from '../../../../conversationWidget/components/JobSelection';
import { AppLayoutTheme } from '../../../utils/CandidateHelper';

interface TalentpoolHeaderProps {
  job?: IJob | null;
  getJob: (args: IJob) => void;
}

const TalentpoolHeader = ({ job, getJob }: TalentpoolHeaderProps) => {
  const [open, setOpen] = useState(false);
  const setJob = (job: IJob) => {
    getJob(job);
    setOpen(false);
  };
  const navigate = useNavigate();
  return (
    <>
      <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
        {job ? (
          <Box mx={2}>
            <Card sx={{ bgcolor: WsColors.TheBlues900, borderRadius: 2, p: 2 }}>
              <Grid container item xs={12}>
                <Grid item xs={6}>
                  <Box>
                    <FormControlLabel
                      control={
                        <IconButton
                          sx={{ color: WsColors.White }}
                          onClick={() => navigate('/candidates')}
                        >
                          <ArrowBack />
                        </IconButton>
                      }
                      label={
                        <Grid container item xs={12} columnGap={1}>
                          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.WHITE}>
                            {job?.title ?? ''}
                          </WsTypography>
                          <WsDotIcon
                            color={WsDotColors.WHITE}
                            textColor={WsDotTextColors.WHITE}
                            value={job?.jobCode ?? ''}
                          />
                          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY}>
                            {`@${job?.companyName}`}
                          </WsTypography>
                        </Grid>
                      }
                    />
                  </Box>
                </Grid>

                <Grid item xs={6} container justifyContent="flex-end" columnGap={1}>
                  <WsButton variant="text" onClick={() => setOpen(true)}>
                    Switch Job
                  </WsButton>
                  <WsDrawer
                    title="Change The Job"
                    open={open}
                    size="medium"
                    headerSize="medium"
                    onClose={() => setOpen(false)}
                  >
                    <JobSelection getJob={setJob} onBackButton={() => setOpen(false)} />
                  </WsDrawer>
                </Grid>
              </Grid>
              <Grid item xs={12} container columnGap={2} ml={3.5}>
                <Stack direction="row">
                  <Box pr={1}>
                    <RiPulseFill color={WsColors.White} />
                  </Box>
                  <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.WHITE}>
                    {`Posted  ${timeSince(String(job?.createdOn))} by ${job?.createdBy ?? ''}`}
                  </WsTypography>
                </Stack>
                <Stack direction="row">
                  <Box pr={1}>
                    <RiPulseFill color={WsColors.White} />
                  </Box>
                  <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.WHITE}>
                    {`Last Updated  ${timeSince(String(job?.createdOn))} by ${
                      job?.createdBy ?? ''
                    }`}
                  </WsTypography>
                </Stack>
              </Grid>
            </Card>
          </Box>
        ) : (
          <AppLayoutTheme>
            <Paper
              sx={{
                height: 73,
                width: '100%',
                borderRadius: 1.2,
                padding: 0,
              }}
            >
              <Grid pt={2} ml={2}>
                <Typography fontSize={24} fontWeight={700}>
                  Talent Pool
                </Typography>
              </Grid>
            </Paper>
          </AppLayoutTheme>
        )}
      </ErrorBoundary>
    </>
  );
};
export default TalentpoolHeader;
